const styles = theme => ({
  title: {
    fontSize: "18px",
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.default,
    fontWeight: "bold"
  },
  tagContainer: {
    // paddingLeft: theme.spacing(1),
    backgroundColor: "#F4F4F4",
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(1),
    //  width: "70%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  avatarContainer: {
    marginRight: theme.spacing(2)
  },
  name: {
    color: "#78A1BB"
  },
  address: {
    fontWeight: "normal !important",
    color: theme.palette.primary.default
  },
  selectButton: {
    width: "100px",
    height: "40px",
    color: `${theme.palette.primary.main} !important`
  },
  selectedButton: {
    width: "100px",
    height: "40px"
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    height: "2px"
  },
  leftContainer: {
    // width: "50%"
  },
  rightContainer: {
    // width: "50%",
    alignItems: "center"
  },
  tagStyles: {
    letterSpacing: 0,
    color: theme.palette.primary.main,
    paddingRight: theme.spacing(1)
  },
  noPartnersText: {
    color: theme.palette.primary.default
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/ShareWithPartner/styles.js